import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { ButtonToolbar } from 'react-bootstrap';
import { connect } from 'react-redux';
import { navigateToProjectReports } from '../../../links/index.jsx';
import { selectOrgGroups } from '../../../../modules/orgGroups.js';
import GroupSearchSelect from '../../../GroupSearchSelect.jsx';

const mapStateToProps = (state) => ({
  groups: selectOrgGroups(state),
});

const groupPropTypes = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
});

groupPropTypes.children = PropTypes.arrayOf(groupPropTypes);

GroupsFilter.propTypes = {
  disabled: PropTypes.bool,
  groups: PropTypes.arrayOf(groupPropTypes),
  selectedGroupIds: PropTypes.arrayOf(PropTypes.number),
};

GroupsFilter.defaultProps = {
  disabled: false,
  groups: [],
  selectedGroupIds: [],
};

const findElementById = (data, id) => {
  for (const item of data) {
    if (item.id === id) {
      return item;
    }
    if (item.children) {
      const result = findElementById(item.children, id);
      if (result) {
        return result;
      }
    }
  }
  return null;
};

const collectAllChildrenIds = (group) => {
  const childIds = [];

  function traverse(node) {
    childIds.push(node.id);
    if (node.children && node.children.length > 0) {
      for (const child of node.children) {
        traverse(child);
      }
    }
  }

  traverse(group);
  return childIds;
};

function GroupsFilter({ disabled, groups, selectedGroupIds }) {
  const selectedCount = selectedGroupIds.length;

  const selectedGroups = selectedGroupIds.reduce((acc, id) => {
    acc[id] = true;
    return acc;
  }, {});

  const handleGroupSelect = useCallback(
    (group) => {
      const groupId = group.id;

      if (selectedGroupIds.includes(groupId)) {
        navigateToProjectReports({
          groups: selectedGroupIds.filter((id) => id !== groupId),
        });
      } else {
        const ids = collectAllChildrenIds(findElementById(groups, groupId));
        navigateToProjectReports({
          groups: [...new Set([...selectedGroupIds, ...ids])],
        });
      }
    },
    [selectedGroupIds, groups]
  );

  const handleClearAll = useCallback(() => {
    navigateToProjectReports({ groups: [] });
  }, []);

  const title = selectedCount ? `${selectedCount} Selected` : 'All';

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">Groups</div>
      <ButtonToolbar>
        <GroupSearchSelect
          groups={groups}
          selectedGroups={selectedGroups}
          onSelectGroup={handleGroupSelect}
          onClearAll={handleClearAll}
          title={title}
          disabled={disabled}
          className="btn-block"
        />
      </ButtonToolbar>
    </div>
  );
}

export default connect(mapStateToProps)(GroupsFilter);
